module.exports = __webpack_public_path__ + "img/function_icon1.0d5ab0a1.jpg";